import * as React from "react";
const SvgHourglass = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, fill: "none", viewBox: "0 0 18 18", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.2, d: "M15 2.25H3m12 13.5H3m.75-13.5c0 1.883.91 3.65 2.441 4.744l5.618 4.012a5.83 5.83 0 0 1 2.441 4.744m0-13.5a5.83 5.83 0 0 1-2.441 4.744L6.19 11.006A5.83 5.83 0 0 0 3.75 15.75" }));
export default SvgHourglass;
